import React from 'react';
import { DateCellProps } from '../types';

export const DateCell: React.FC<DateCellProps> = ({
  date,
  format = 'date',
  fallback = '-',
  className = '',
}) => {
  const formatDate = (dateValue: string | Date): string => {
    try {
      const dateObj = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;

      if (isNaN(dateObj.getTime())) {
        return fallback;
      }

      switch (format) {
        case 'datetime':
          return dateObj.toLocaleString();
        case 'relative': {
          const now = new Date();
          const diff = now.getTime() - dateObj.getTime();
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));

          if (days === 0) return 'Today';
          if (days === 1) return 'Yesterday';
          if (days < 7) return `${days} days ago`;
          if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
          if (days < 365) return `${Math.floor(days / 30)} months ago`;
          return `${Math.floor(days / 365)} years ago`;
        }
        case 'date':
        default:
          return dateObj.toLocaleDateString();
      }
    } catch (error) {
      return fallback;
    }
  };

  return (
    <span className={`text-sm text-gray-600 dark:text-gray-400 ${className}`}>
      {formatDate(date)}
    </span>
  );
};
